<template>
  <div class="matrix-grid" :class="verticalAlignmentClass()">
    <template v-for="(element, index) in gridElements">
      <div :class="getColClass(element.sort_order)">
        <div>
          <div :data-index="index" :data-id="index">
            <component v-if="element.client_id" :key="element.client_id"
                       :is="componentType(element)"
                       :is-in-edit-mode="isInEditMode"
                       :content-element="element"
                       :entry="entry"
            ></component>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {VerticalAlignment} from "~/enums/verticalAlignment";
  import DetailViewContentElement from "../../../common/models/detailView/elements/detailViewContentElement";
  import {DetailViewContentElementType} from "../../../common/enums/detailViews/detailViewContentElementType";
  import GridDefinition from '../../../common/definitions/gridDefinition'
  import ContentElementComponent from "./content-element-component.vue";

  export default Vue.extend({
    extends: ContentElementComponent,
    props: {
      isInEditMode: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        VerticalAlignment: VerticalAlignment,
        DetailViewContentElementType
      }
    },
    methods: {
      getColClass(sortOrder): string {
        let l = this.layoutConfig[sortOrder % this.layoutConfig.length];
        let sum = this.layoutConfig.reduce((total, current) => total + parseInt(current, 10), 0);
        let i = l / sum * 12;
        return `col-lg-${i} col-md-${i} col-sm-${i}`;
      },
      componentType(element){
        if (this.isInEditMode) {
          return 'detail-view-edit-element-base';
        } else {
          return 'detail-view-content-element-base';
        }
      },
      verticalAlignmentClass(): string {
        return GridDefinition.getVerticalAlignmentClass(this.contentElement.vertical_alignment)
      }
    },
    computed: {
      layoutConfig(): number[] {
        return this.contentElement.layout_config || [1];
      },
      gridElements: {
        get() {
          let result = [];
          let keys = Object.keys(this.contentElement.content_elements);
          for (let i = 0; i < keys.length; i++) {
            let element = this.contentElement.content_elements[keys[i]];
            result[element.sort_order] = element;
          }
          let maxSortOrder = keys
            .map(key => this.contentElement.content_elements[key].sort_order)
            .reduce((maxValue, value) => Math.max(maxValue, value), 0);
          // even out drop zones
          if (keys.length > 0) {
            maxSortOrder +=
              this.layoutConfig.length -
              maxSortOrder % this.layoutConfig.length;
          }
          for (let i = 0; i < maxSortOrder; i++) {
            if (!result[i]) {
              result[i] = {sort_order: i}
            }
          }
          return result;
        }
      }
    },

  });
</script>